import { ArrowBack, Image } from '@mui/icons-material';
import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { twMerge } from 'tailwind-merge';
import { v4 as uuidv4 } from 'uuid';

import nf, { nfRp } from '@/constants/nf';
import { useNavigate } from 'react-router-dom';
import { route } from '@/constants/routeName';
import slugify from 'slugify';
import { isMealDateOrderable } from '@/helper/mealDateOrderable';

export default function ItemList(props) {
	const { itemsList } = props;
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const history = useSelector((state) => state.cart.historyCollection);
	const orderDate = useSelector((state) => state.cart.orderDate);
	const accountType = useSelector((state) => state.auth.accountType);
	const servingTimes = useSelector((state) => state.content.servingTimes);
	const isParent = accountType === 'parent';
	const sessionTags = (servingTimes || [])
		.filter((s) => s?.name && String(s.name).toLowerCase() !== 'void')
		.map((s) => s.name)
		.join(' / ');

	const canOrderDate = useMemo(() => isMealDateOrderable(orderDate), [orderDate]);

	const onClickItem = (type, data) => {
		if (!canOrderDate && type === 'item') return;
		if (type === 'item') {
			dispatch({ type: 'cart/setSelectedItem', payload: data });
			navigate(`/${route.item}/${slugify(data.name.toLowerCase(), '-')}`);
		}
		if (type === 'collection') {
			dispatch({ type: 'cart/setHistoryCollection', payload: { type: 'add', data } });
		}
	};

	const onRemoveHistory = () => {
		dispatch({ type: 'cart/setHistoryCollection', payload: { type: 'remove' } });
	};

	if (isParent) {
		return (
			<div className='menu-grid'>
				{history?.length > 0 && (
					<button type='button' className='grid-tile collection' onClick={onRemoveHistory}>
						<div className='menu-photo no-image'>
							<ArrowBack style={{ color: 'black' }} />
						</div>
						<span className='tile-name'>Back</span>
					</button>
				)}
				{itemsList.map((f) => {
					const isItems = !('collection' in f);
					const objItems = isItems ? f.product : f.collection;
					let data = { ...objItems };
					if (isItems) {
						data.price = +data.selling_price;
						data.uid = uuidv4();
					}

					return (
						<button
							key={`${data.id}-${data.name}`}
							type='button'
							className={twMerge(
								'grid-tile',
								!isItems && 'collection',
								!canOrderDate && isItems && 'disabled'
							)}
							aria-disabled={!canOrderDate && isItems ? true : undefined}
							onClick={() => onClickItem(isItems ? 'item' : 'collection', data)}
						>
							{data.thumbnail ? (
								<img className='menu-photo' src={data.thumbnail} alt={data.name} loading='eager' />
							) : (
								<div className='menu-photo no-image' role='img' aria-label={data.name}>
									<Image />
								</div>
							)}
							<span className='tile-name'>{data.name}</span>
							{isItems && <span className='tile-price'>{nfRp(data.price)}</span>}
							{isItems && !canOrderDate ? (
								<span className='tile-session'>View only</span>
							) : isItems && sessionTags ? (
								<span className='tile-session'>{sessionTags}</span>
							) : null}
						</button>
					);
				})}
			</div>
		);
	}

	return (
		<>
			{history?.length > 0 && (
				<button
					className='food-cards transition-transform duration-100 active:scale-[0.98] active:opacity-80'
					onClick={onRemoveHistory}
				>
					<div className='no-image'>
						<ArrowBack style={{ color: 'black' }} />
					</div>
					<div className='collection'>
						<span className={twMerge('text-center text-base font-bold')}>Back</span>
					</div>
				</button>
			)}
			{itemsList.map((f) => {
				const isItems = !('collection' in f);
				const objItems = isItems ? f.product : f.collection;
				let data = { ...objItems };
				if (isItems) {
					data.price = +data.selling_price;
					data.uid = uuidv4();
				}

				return (
					<button
						key={`${data.id}-${data.name}`}
						className={twMerge(
							'food-cards transition-transform duration-100 active:scale-[0.98] active:opacity-80',
							!canOrderDate && isItems ? 'disabled' : ''
						)}
						aria-disabled={!canOrderDate && isItems ? true : undefined}
						onClick={() => onClickItem(isItems ? 'item' : 'collection', data)}
					>
						{data.thumbnail ? (
							<img src={data.thumbnail} alt={data.name} loading='eager' />
						) : (
							<div className='no-image'>
								<Image />
							</div>
						)}
						<div className={twMerge(!isItems ? 'collection' : '')}>
							<span className={twMerge('text-center font-bold', !isItems ? 'text-sm' : 'text-sm')}>
								{data.name}
							</span>
							{isItems && (
								<span className='text-sm font-bold text-center'>{nf(data.price)}</span>
							)}
						</div>
					</button>
				);
			})}
		</>
	);
}
